import { gql } from "@apollo/client";

export const PUBLISH_MEASURE_MUTATION = gql`
  mutation PublishMeasure($input: PublishMeasureInput!) {
    publishMeasure(input: $input) {
      auditId
      mesure {
        id
        status
      }
    }
  }
`;

export const TRANSITION_MEASURE_MUTATION = gql`
  mutation TransitionMeasure($input: TransitionMeasureInput!) {
    transitionMeasure(input: $input) {
      auditId
      mesure {
        id
        status
      }
    }
  }
`;
